import { Calendar, Users, Star, Trophy } from 'lucide-react';
import { VinylDisc, Sparkle, DancingCouple } from '../components/CartagenaIllustrations';
import { useLanguage } from '../contexts/LanguageContext';
// Galería de fotos del festival (placeholders - reemplazar con fotos reales)
const galleryImages = [
  {
    url: '/im1.jpg',
    caption: 'Baile champeta en vivo'
  },
  {
    url: '/im2.jpg',
    caption: 'Comunidad celebrando'
  },
  {
    url: '/im3.jpg',
    caption: 'Arte callejero cartagenero'
  },
  {
    url: '/im4.jpg',
    caption: 'Artistas en escenario'
  },
  {
    url: '/im5.jpg',
    caption: 'Energía del público'
  },
  {
    url: '/im6.jpg',
    caption: 'Momentos únicos'
  }
];





export default function FestivalPage() {
  const { t } = useLanguage();

  const stats = [
    { icon: Users, value: '500+', label: t('festival.stats.attendees'), color: 'var(--cartagena-green)' },
    { icon: Star, value: '8', label: t('festival.stats.artists'), color: 'var(--cartagena-yellow)' },
    { icon: Calendar, value: '2', label: t('festival.stats.editions'), color: 'var(--cartagena-red)' },
    { icon: Trophy, value: '100%', label: t('festival.stats.satisfaction'), color: 'var(--caribbean-deep)' }
  ];
  return (

    <div className="min-h-screen bg-[var(--background)]">
      {/* Hero Section */}
      <section className="relative py-32 overflow-hidden" style={{ backgroundColor: 'var(--dark-section)' }}>
        <div className="absolute inset-0 opacity-20">
          <img
            src="/FestivalBanner.jpg"
            alt="Festival background"
            className="w-full h-full object-cover object-top"
          />
        </div>

        {/* Decorative elements */}
        <div className="absolute top-20 left-10 opacity-50 hidden md:block">
          <VinylDisc size={80} />
        </div>
        <Sparkle size={24} className="absolute top-32 right-20" color="var(--cartagena-yellow)" />

        <div className="container-festival relative z-10 text-center">
          <span className="inline-block px-4 py-2 bg-[var(--cartagena-red)] text-white font-bold uppercase text-sm tracking-widest rounded-lg mb-6 border-2 border-[var(--cartagena-yellow)]">
            {t('festival.hero.badge')}
          </span>
          <h1 className="font-['Titan_One'] text-4xl md:text-6xl lg:text-7xl uppercase text-white mb-6">
            {t('festival.hero.title1')}  <span className="text-[var(--cartagena-yellow)]">{t('festival.hero.title2')} </span>
          </h1>
          <p className="text-white/80 text-lg md:text-xl max-w-3xl mx-auto">
            {t('festival.hero.description')}
          </p>
        </div>

        {/* Decorative stripes */}
        <div className="absolute bottom-0 left-0 w-full h-3 bg-[var(--cartagena-green)]" />
        <div className="absolute bottom-3 left-0 w-full h-2 bg-[var(--cartagena-yellow)]" />
        <div className="absolute bottom-5 left-0 w-full h-1 bg-[var(--cartagena-red)]" />
      </section>

      {/* Stats Section */}
      <section className="py-16 bg-[var(--muted)]">
        <div className="container-festival">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
            {stats.map((stat, index) => (
              <div
                key={index}
                className="text-center p-6 bg-white rounded-2xl border-2 border-[var(--foreground)] pico-shadow"
              >
                <div
                  className="w-12 h-12 mx-auto mb-4 flex items-center justify-center rounded-xl"
                  style={{ backgroundColor: stat.color }}
                >
                  <stat.icon className="w-6 h-6 text-white" />
                </div>
                <p className="font-['Titan_One'] text-3xl md:text-4xl" style={{ color: stat.color }}>
                  {stat.value}
                </p>
                <p className="text-[var(--foreground)]/70 text-sm uppercase tracking-wider mt-1">
                  {stat.label}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Our Story Section */}
      <section className="py-20 md:py-5">
        <div className="container-festival">
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div>
              <span className="inline-block px-4 py-2 bg-[var(--cartagena-green)] text-white font-bold uppercase text-sm tracking-widest rounded-lg mb-4">
                {t('festival.origin.badge')}
              </span>
              <h2 className="font-['Titan_One'] text-3xl md:text-4xl uppercase text-[var(--foreground)] mb-6">
                {t('festival.origin.title1')} <span className="text-[var(--cartagena-red)]">{t('festival.origin.title2')}</span>?
              </h2>
              <div className="space-y-4 text-[var(--foreground)]/80">
                <p>
                  {t('festival.origin.p1')}
                </p>
                <p>
                  {t('festival.origin.p2')}
                </p>
                <p>
                  {t('festival.origin.p3')}
                </p>
              </div>
            </div>
            <div className="relative">
              <div className="aspect-square rounded-2xl overflow-hidden border-4 border-[var(--foreground)] pico-shadow">
                <img
                  src="/NacioPic.jpg"
                  alt="Comunidad Champeta"
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="absolute -bottom-6 -right-6 hidden md:block">
                <DancingCouple size={100} />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Photo Gallery */}
      <section className="py-20 md:py-5">
        <div className="container-festival">
          <div className="text-center mb-16">
            <span className="inline-block px-4 py-2 bg-[var(--cartagena-red)] text-white font-bold uppercase text-sm tracking-widest rounded-lg mb-4">
              {t('festival.gallery.badge')}
            </span>
            <h2 className="font-['Titan_One'] text-3xl md:text-5xl uppercase text-[var(--foreground)]">
              {t('festival.gallery.title1')} <span className="text-[var(--cartagena-green)]">{t('festival.gallery.title2')}</span>
            </h2>
            <p className="text-[var(--foreground)]/70 mt-4 max-w-2xl mx-auto">
              {t('festival.gallery.description')}
            </p>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-3 gap-4 md:gap-6">
            {galleryImages.map((image, index) => (
              <div
                key={index}
                className="group relative aspect-square rounded-2xl overflow-hidden border-2 border-[var(--foreground)] cursor-pointer"
              >
                <img
                  src={image.url}
                  alt={image.caption}
                  className="w-full h-full object-cover transform group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <div className="absolute bottom-4 left-4 right-4">
                    <p className="text-white font-bold text-sm">{image.caption}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20" style={{ backgroundColor: 'var(--muted)' }}>
        <div className="container-festival text-center">
          <h2 className="font-['Titan_One'] text-3xl md:text-4xl uppercase text-[var(--foreground)] mb-6">
            {t('festival.cta.title1')}<span className="text-[var(--cartagena-red)]">{t('festival.cta.title2')}</span>?
          </h2>
          <p className="text-[var(--foreground)]/70 mb-8 max-w-2xl mx-auto">
            {t('festival.cta.description')}
          </p>
          <a
            href="https://forms.gle/VsboZ2tgn5LjgL9c6"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-block px-8 py-4 bg-[var(--cartagena-green)] text-white font-bold uppercase tracking-wider rounded-xl border-2 border-[var(--foreground)] pico-shadow hover:bg-[var(--cartagena-green)]/90 transition-colors"
          >
            {t('festival.cta.button')}
          </a>
        </div>
      </section>
    </div>
  );
}
